import React from 'react';
import ReactDOM from 'react-dom';
import AppWrapper from '../mvp/AppWrapper';

export function renderInteractiveUI() {
    ReactDOM.render(
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', transform: 'none' }} tabIndex="-1">
            <AppWrapper epsOnly={window.epsOnly} />
        </div>,
        document.getElementById('app-root')
    );
}